import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'spb-badge',
  templateUrl: './badge.component.html',
})
export class BadgeComponent implements OnInit {
  @HostBinding('class.spb-badge') hostBaseClass = true;
  @Input() color = '#EF2964';

  constructor() { }

  ngOnInit() {
  }

}
